<template>
  <v-card>
    <v-row justify="center">
      <v-col cols="11">
        <v-card>
          <v-card-title justify="space-around" class="text-center">
            <v-row justify="center">
              <v-col cols="9">
                <h3 class="heading_three">
                  {{ $t('L_confirm_your_payment_option') }}
                </h3>
                <h4
                  class="mt-3 font-weight-regular"
                  v-html="$t('L_primerica_life_will_send_you_a_bill_for')"
                />
              </v-col>
            </v-row>
          </v-card-title>
          <DirectPaymentPlaceHolder>
            <template v-slot:paymentType>
              {{ billMode }}
            </template>
            <template v-slot:premiumAmountPanel>
              <v-row justify="center" class="mx-4">
                <v-col cols="12" sm4>
                  <v-row justify="center">
                    <v-col cols="12" class="font-weight-600 text-center">
                      {{ $t('L_premium_amount') }}
                    </v-col>
                  </v-row>
                  <v-row justify="center" class="mt-2">
                    <v-col cols="12" class="text-center">
                      {{ selectedPremiumAmount }}
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </template>
            <!-- <template
              v-slot="paymentAmountLabel"
            >
              {{ $t('L_premium_amount') }}
            </template>
            <template
              slot="paymentAmount"
            >
              {{ selectedPremiumAmount }}
            </template>
            <template
              v-slot="nextPaymentDateLabel"
            >
              {{ $t('L_due_date') }}
            </template>
            <template
              v-slot="nextPaymentDate"
            >
              06/01/2020
            </template> -->
            <template v-slot:billingInformationLabel>
              {{ $t('L_billing_information') }}
            </template>
            <template v-slot:description>
              <a
                href="javascript:void(0)"
                @click="$emit('open-contact-details')"
                class="text-decoration-underline"
              >
                {{ $t('L_contact_details') }}
              </a>
            </template>
            <template v-slot:mailingAddressLabel>
              {{ $t('L_mailing_address') }}
            </template>
            <template v-slot:address>
              <v-col cols="12">
                {{ selpackage.addrLine1 }}
              </v-col>
              <v-col cols="12">
                {{ selpackage.addrLine2 }}
              </v-col>
              <v-col cols="12">
                {{ selpackage.addrCity }}, {{ selpackage.addrState }} {{ selpackage.addrZip }}
              </v-col>
            </template>
          </DirectPaymentPlaceHolder>
          <v-card-actions>
            <v-row justify="center" class="py-4">
              <v-col cols="7" class="my-2">
                <OnexButton block color="primary" @click="$emit('open-edelivery')">
                  {{ $t('L_i_authorize') }}
                </OnexButton>
              </v-col>
              <v-col cols="7" class="my-2">
                <OnexButton
                  id="direct_payment_cancel_trigger"
                  block
                  color="default"
                  aria-label="Close"
                  @click="$emit('display-warning')"
                >
                  {{ $t('L_cancel') }}
                </OnexButton>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>
<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import DirectPaymentPlaceHolder from '@/components/DirectPayment/DirectPaymentComponent.vue';
import stringValues from '@/shared/util/stringValues';
import { mapState } from 'pinia';
import { useChildRiderStore } from '@/modules/childrider/store/childrider.store';
import { OnexButton } from '@primerica/onex-ui-lib';

const componentOptions: ComponentOptions = {
  name: 'ConfirmDirectBillPayment',
  components: {
    DirectPaymentPlaceHolder,
    OnexButton,
  },
  computed: {
    ...mapState(useChildRiderStore, {
      selpackage: 'NPPackage',
      NPSelectedPremiumAmount: 'NPSelectedPremiumAmount',
    }),
    selectedPremiumAmount() {
      return `$${this.NPSelectedPremiumAmount}`;
    },
    billMode() {
      // Adding Quarterly here for C2, D2, H1
      if (
        this.selpackage?.paymentForm === 'C2' ||
        this.selpackage?.paymentForm === 'D2' ||
        this.selpackage?.paymentForm === 'H1' ||
        (this.selpackage?.paymentForm === 'A1' && this.selpackage?.paymentMode === '1')
      ) {
        return stringValues.billingMode('3');
      }
      return stringValues.billingMode(this.selpackage?.paymentMode);
    },
  },
};

export default defineComponent(componentOptions);
</script>
